export default "__VITE_ASSET__zQVEo1CA__"